<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }" is-range
            class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseSelect :options="orgSelect.options" :data="orgSelect.data" ref="orgSelect">
        </BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseInput :options="codeInput.options" :data="codeInput.data" :listener="codeInput.listener" />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary" @click="$router.push('/administrator/managed-license-add.html')">
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-else>
            </td>
          </template>
          <template #startDate="{ item }">
            <td v-if="item.startDate != null">
              {{ $helper.formatDateDDMMYYYY(item.startDate) }}
            </td>
            <td v-else>
            </td>
          </template>
          <template #endDate="{ item }">
            <td v-if="item.endDate != null">
              {{ $helper.formatDateDDMMYYYY(item.endDate) }}
            </td>
            <td v-else>
            </td>
          </template>
          <template #cost="{ item }">
            <td v-if="item.cost != null">
              {{ $helper.formatPriceDot(item.cost) }}
            </td>
            <td v-else>
            </td>
          </template>
          <template #maxDevice="{ item }">
            <td v-if="item.maxDevice != null">
              {{ $helper.formatPriceDot(item.deviceUse) + "/" + $helper.formatPriceDot(item.maxDevice) }}
            </td>
            <td v-else>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="danger" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Xóa'"
                  @click="
                    setupSelectOneAction('delete_one', item.id, item.code)
                  ">
                  <CIcon name="cil-trash" />
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import { DatePicker } from "v-calendar";
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2"

export default {
  name: "LicenseList",
  components: {
    DatePicker,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/license/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "license",
          that.actionData.model.code
        );
      },
      isJsonContentType: false,
      // type: 'PUT',
      dataSubmit: function () {
        return { id: that.actionData.model.licenseSelectedId };
      },
      successCallback: function () {
        that.showSuccessMsg({ message: "Xóa license " + that.actionData.model.code + " thành công" });
        that.loadDataMainTable();
      }
    });

    return {
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          licenseSelectedId: null,
          code: null
        }
      },
      dateRange: {
        start: that.$helper.subtractNowDateYear(1).setHours(0, 0, 0, 0),
        end: new Date()
      },
      codeInput: {
        options: {
          placeholder: "Mã license",
          label: 'Mã license'
        },
        data: {
          name: "code",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      orgSelect: {
        options: {
          label: "Đơn vị",
          selectAllText: "Tất cả đơn vị",
          filter: true,
          keyField: "value",
          valueField: "text",
        },
        data: {
          model: null,
          name: "orgId",
          source: {
            url: "/organization/list-org-active",
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            // {key: "checkbox", label: "#"},
            { key: "index", label: "STT" },
            { key: "createDate", label: "Ngày tạo" },
            { key: "code", label: "Mã" },
            { key: "startDate", label: "Ngày bắt đầu" },
            { key: "endDate", label: "Ngày kết thúc" },
            { key: "cost", label: "Đơn giá" },
            { key: "maxDevice", label: "Số lượng thiết bị" },
            { key: "orgName", label: "Đơn vị" },
            { key: "action", label: "Thao tác" }
          ],
          slots: ["index", "createDate", "startDate", "endDate", "cost", "maxDevice", "action"],
          pageSize: 15,
          lazyLoad: true
        },
        dataSource: {
          url: "/license/page",
          dataSubmit: function () {
            return {
              fromDate: that.$helper.formatDate(that.dateRange.start),
              toDate: that.$helper.formatDate(that.dateRange.end),
              code: that.codeInput.data.model
            }
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, licenseSelectedId, code) {
      let actionData = this.actionData.model;
      actionData.licenseSelectedId = licenseSelectedId || null;
      actionData.code = code || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date(),
          end: new Date()
        }
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
